RshopApp.$mount('.l-header');

function cartStatusTracking(response) {
    var cartItems = [];

    for (key in response.products) {
        var item = response.products[key];
        cartItems.push({
            productId: item.id,
            productCartId: item.id,
            productName: item.name,
            productPrice: item.price_vat,
            productPriceNoVat: item.price,
            productStatus: item.custom_status,
            categoryName: item.custom_category,
            manufacturerName: item.manufacturer_name,
            variantName: '',
            quantity: item.quantity,
        });
    }

    var eventData = {
        event: 'cart_status',
        ecommerce: {
            cart_id: Eshop.options.cart_id,
            cart_items: cartItems,
            totalValue: response.totals.subtotal,
            totalValueVAT: response.totals.total,
        },
    };

    if (response.custom) {
        eventData.order = {
            coupon: response.custom.voucher,
            discount: response.custom.discount,
        };
    }

    dataLayer.push({ ecommerce: null });
    dataLayer.push(eventData);
}

// aby toto fungovalo, treba v: vendor/rshop/frontend/resources/js/cart.js:13 do metody removedItem pridat Cart.customCallbacks.removedItem(response);
Cart.customCallbacks.removedItem = function(response) {
    cartStatusTracking(response);
};

Cart.customCallbacks.updatedItem = function(input, response) {
    cartStatusTracking(response);
};

Cart.customCallbacks.addedItem = function(form, response) {
    var $submitButton = $(form).find('[type="submit"]');

    if (!response.status) {
        $submitButton.addClass('has-error');
    }

    $submitButton
        .addClass('is-loaded')
        .removeClass('is-loading')
        .prop('disabled', false);

    $submitButton.one(
        'animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd',
        function() {
            $submitButton.removeClass('is-loaded');
        }
    );

    cartStatusTracking(response);
};

rEvent.on('Cart.product.before_add', function(form) {
    $(form)
        .find('[type="submit"]')
        .removeClass('has-error')
        .addClass('is-loading')
        .prop('disabled', true);
});

Listing.customCallbacks.afterFetch = function() {
    rEvent.dispatch('Listing.afterFetch');

    bLazy.revalidate();

    createTippy();

    setTimeout(function() {
        bLazy.revalidate();
    }, 250);

    if ($('.pager__load').length && $('.pager__load').hasClass('is-loading')) {
        $('.pager__load').removeClass('is-loading');
    }
};

Eshop.alert = function(msg, options) {
    var settings = $.extend(
        {
            allow_dismiss: true,
            type: 'success',
            animate: {
                enter: 'fadeInRight',
                exit: 'fadeOutRight',
            },
            placement: {
                from: 'bottom',
            },
            gap: 2,
            delay: 4500,
            mouse_over: 'pause',
            offset: {
                y: 15,
            },
            z_index: 3003,
            template:
                '<div data-notify="container" class="notify custom {0}" role="alert">' +
                '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">' +
                '<i class="ico icon-close" aria-hidden="true"></i>' +
                '</button>' +
                '<span class="message" data-notify="message">{2}</span>' +
                '</div>',
        },
        options
    );

    $.notify(msg, settings);
};

function initTippy(theme, options) {
    if (typeof options === 'undefined') {
        options = {};
    }

    $('.js-tippy-' + theme).each(function() {
        if (typeof this._tippy !== 'undefined') {
            this._tippy.destroy();
        }
    });

    tippy(
        '.js-tippy-' + theme,
        $.extend(
            {
                arrow: true,
                theme: theme,
                dynamicTitle: true,
                animation: 'shift-away',
                duration: [300, 180],
                inertia: true,
            },
            options
        )
    );
}

function createTippy() {
    initTippy('white');
    initTippy('seasonal', {
        interactive: true,
        interactiveBorder: 24,
        hideOnClick: false,
    });
    initTippy('explosion', {
        interactive: true,
        interactiveBorder: 24,
        trigger: 'click',
        allowHtml: true,
    });
}

$(function() {
    createTippy();

    $('.js-custom-form-modal-login').validate({
        rules: {
            login: {
                email: true,
            },
        },
        submitHandler: function(form) {
            $(form)
                .find('button[type="submit"]')
                .addClass('is-loading');

            $('.js-login-error').slideUp(150);

            Form.ajaxPost(
                form,
                function(data) {
                    $('.js-login-error').hide();

                    if (!data.status) {
                        $('.js-login-error')
                            .text(data.message)
                            .slideDown();
                    } else {
                        $('.js-login-hide').slideUp(150, function() {
                            $('.js-login-success').slideDown(150);
                        });

                        setTimeout(function() {
                            location.reload();
                        }, 300);
                    }

                    $(form)
                        .find('button[type="submit"]')
                        .removeClass('is-loading');
                },
                'json'
            );
        },
    });
});

if (typeof categories != 'undefined') {
    new Vue({
        el: '#v-categories',
        data: {
            allCategories: Object.values(categories),
            selectedCategoryId: selectedCategoryId,
            forceSiblingsView: false,
            showSubcategories: true,
            showAllCategories: checkResolution('cxs;xs') ? false : true,
        },
        created: function() {
            var _self = this;

            _self.allCategories = _self.allCategories.filter(function(
                category
            ) {
                return _self.hasActivePath(category);
            });

            if (this.selectedCategoryId != null) {
                for (var index = 0; index < this.categories.length; index++) {
                    if (
                        this.categories[index].id == this.selectedCategoryId &&
                        index > 5
                    ) {
                        this.showAllCategories = true;
                    }
                }
            }
        },
        methods: {
            change: function(event) {
                var input = event.currentTarget;

                if (!input.checked) {
                    this.selectedCategoryId = parseInt(input.dataset.parent);
                } else {
                    this.selectedCategoryId = parseInt(input.dataset.id);
                }

                this.submitFilter();
            },
            back: function() {
                this.selectedCategoryId = this.showSubcategories
                    ? this.selectedCategoryId
                    : this.category.parent_id;

                // root category fix
                if (this.category.parent_id == null) {
                    this.selectedCategoryId = null;
                    this.showSubcategories = true;
                }

                this.forceSiblingsView = true;
                this.showAll = false;
                this.showAllCategories = checkResolution('cxs;xs')
                    ? false
                    : true;

                this.submitFilter();
            },
            checked: function(categoryId) {
                return categoryId == this.selectedCategoryId;
            },
            submitFilter: function() {
                setTimeout(function() {
                    Filter.submit();
                    Filter.refreshBubbles();
                }, 500);
            },
            hasActivePath: function(category) {
                return true;
            },
            getSubcategories: function(categoryId) {
                var _self = this;

                return _self.allCategories.filter(function(category) {
                    return category.parent_id == categoryId;
                });
            },
            showHiddenCategories: function() {
                this.showAllCategories = true;
            },
        },
        computed: {
            category: function() {
                var _self = this;

                if (!_self.selectedCategoryId) {
                    return null;
                }

                return _self.allCategories.filter(function(category) {
                    return category.id == _self.selectedCategoryId;
                })[0];
            },
            subcategories: function() {
                return this.getSubcategories(this.selectedCategoryId);
            },
            siblings: function() {
                var selectCategoryId =
                    this.selectedCategoryId == null
                        ? null
                        : this.category.parent_id;

                return this.allCategories.filter(function(category) {
                    return selectCategoryId == category.parent_id;
                });
            },
            categories: function() {
                if (this.subcategories.length > 0 && !this.forceSiblingsView) {
                    this.showSubcategories = true;
                    return this.subcategories;
                }

                this.forceSiblingsView = false;
                this.showSubcategories = false;

                return this.siblings;
            },
            showBackButton: function() {
                if (this.selectedCategoryId == null) {
                    return false;
                }

                if (this.category.parent_id != null) {
                    return true;
                }

                return this.showSubcategories;
            },
            showAllButton: function() {
                return !this.showAllCategories && this.categories.length > 6;
            },
        },
    });
}

rEvent.on('Listing.fetchedData', function(data) {
    $('.listing-plural-text').addClass('hidden');
    if (data.count == 1) {
        $('.listing-plural-text[data-count="1"]').removeClass('hidden');
    }

    if (data.count > 1 && data.count < 5) {
        $('.listing-plural-text[data-count="2"]').removeClass('hidden');
    }

    if (data.count > 4 || data.count == 0) {
        $('.listing-plural-text[data-count="5"]').removeClass('hidden');
    }

    if (!data.entity) {
        return;
    }

    // change heading
    var baseName = data.entity.name,
        name = baseName;

    if (data.entity && data.entity.heading) {
        name = data.entity.heading;
    } else if (data.filtered_parameters) {
        name =
            baseName + ' ' + Object.values(data.filtered_parameters).join(' ');
    }

    if (!name) {
        return;
    }

    $('.js-catalog-header .listing-heading').html(name);

    var title = document.title.split(' | ');

    document.title = name + ' | ' + title[1];
});
